import React from 'react';

export interface MailProps {
  className?: string;
}

const Mail: React.FC<MailProps> = ({ className }) => {
  return (
    <svg viewBox="0 0 17 12" fill="none" className={className}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.5 7.25L2.5 2.75V10H14.5V2.75L8.5 7.25ZM16.5 12H0.5V0H16.5V12ZM12.1667 2H4.83333L8.5 4.75L12.1667 2Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default Mail;
